/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareClaimAccessResponseData
 */
export interface ShareClaimAccessResponseData {
    /**
     * 
     * @type {number}
     * @memberof ShareClaimAccessResponseData
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ShareClaimAccessResponseData
     */
    claimId: number;
    /**
     * 
     * @type {string}
     * @memberof ShareClaimAccessResponseData
     */
    principalType: ShareClaimAccessResponseDataPrincipalTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ShareClaimAccessResponseData
     */
    principalId: number;
    /**
     * 
     * @type {string}
     * @memberof ShareClaimAccessResponseData
     */
    accessLevel: ShareClaimAccessResponseDataAccessLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShareClaimAccessResponseData
     */
    blockedModules?: Array<ShareClaimAccessResponseDataBlockedModulesEnum>;
    /**
     * 
     * @type {number}
     * @memberof ShareClaimAccessResponseData
     */
    grantedByUserId: number;
}


/**
 * @export
 */
export const ShareClaimAccessResponseDataPrincipalTypeEnum = {
    User: 'user',
    Company: 'company'
} as const;
export type ShareClaimAccessResponseDataPrincipalTypeEnum = typeof ShareClaimAccessResponseDataPrincipalTypeEnum[keyof typeof ShareClaimAccessResponseDataPrincipalTypeEnum];

/**
 * @export
 */
export const ShareClaimAccessResponseDataAccessLevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type ShareClaimAccessResponseDataAccessLevelEnum = typeof ShareClaimAccessResponseDataAccessLevelEnum[keyof typeof ShareClaimAccessResponseDataAccessLevelEnum];

/**
 * @export
 */
export const ShareClaimAccessResponseDataBlockedModulesEnum = {
    Comparisons: 'comparisons',
    Documents: 'documents',
    Photos: 'photos',
    Links: 'links',
    Tasks: 'tasks',
    Supplements: 'supplements',
    Forms: 'forms',
    Financials: 'financials',
    Emails: 'emails',
    Notes: 'notes'
} as const;
export type ShareClaimAccessResponseDataBlockedModulesEnum = typeof ShareClaimAccessResponseDataBlockedModulesEnum[keyof typeof ShareClaimAccessResponseDataBlockedModulesEnum];


/**
 * Check if a given object implements the ShareClaimAccessResponseData interface.
 */
export function instanceOfShareClaimAccessResponseData(value: object): value is ShareClaimAccessResponseData {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('principalType' in value) || value['principalType'] === undefined) return false;
    if (!('principalId' in value) || value['principalId'] === undefined) return false;
    if (!('accessLevel' in value) || value['accessLevel'] === undefined) return false;
    if (!('grantedByUserId' in value) || value['grantedByUserId'] === undefined) return false;
    return true;
}

export function ShareClaimAccessResponseDataFromJSON(json: any): ShareClaimAccessResponseData {
    return ShareClaimAccessResponseDataFromJSONTyped(json, false);
}

export function ShareClaimAccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimAccessResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'principalType': json['principalType'],
        'principalId': json['principalId'],
        'accessLevel': json['accessLevel'],
        'blockedModules': json['blockedModules'] == null ? undefined : json['blockedModules'],
        'grantedByUserId': json['grantedByUserId'],
    };
}

export function ShareClaimAccessResponseDataToJSON(json: any): ShareClaimAccessResponseData {
    return ShareClaimAccessResponseDataToJSONTyped(json, false);
}

export function ShareClaimAccessResponseDataToJSONTyped(value?: ShareClaimAccessResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claimId': value['claimId'],
        'principalType': value['principalType'],
        'principalId': value['principalId'],
        'accessLevel': value['accessLevel'],
        'blockedModules': value['blockedModules'],
        'grantedByUserId': value['grantedByUserId'],
    };
}

